<template>
<v-container>
    <v-text-field v-model="search" placeholder="Rechercher une intervention" prepend-inner-icon="mdi-magnify" append-icon="mdi-filter-variant" filled rounded dense class="mb-4" ></v-text-field>

    <v-row>
    <v-col cols="12" v-for="item in filteredList" :key="item.ass_id" class="pa-2">
        <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 1 : 3" class="rounded-xl pa-4" style="cursor:pointer;" 
                :to="{ name: 'assignments-edit', params: { ass_id: item.ass_id } }">
                <v-row no-gutters>
                    <v-col cols="2" class="">
                        <v-icon size="60" :color="'blue'" class="mr-4">mdi-map-marker-right-outline</v-icon>
                    </v-col>
                    <v-col cols="7" class="">
                        <span class="text-h6 font-weight-bold mr-2 text-uppercase"><v-icon>mdi-map-marker-plus-outline</v-icon>&nbsp;{{ item.sit_name }}</span><br />
                        <span class="body-2 grey--text text--darken-2 text-truncate"><v-icon>mdi-map-marker-minus-outline</v-icon>&nbsp;{{ item.old_sit_name }}</span><br />
                        
                        <v-chip :x-small="$root.$mobileView" class="ma-2" label outlined :color="stateListById[item.ass_sta_id].sta_color">
                            {{ stateListById[item.ass_sta_id].sta_label }}
                        </v-chip>
                        <v-chip :x-small="$root.$mobileView" class="ma-2" label outlined :color="typeListById[item.ass_typ_id].typ_color">{{ typeListById[item.ass_typ_id].typ_name }}</v-chip>
                    </v-col>
                    <v-col cols="3" class="text-right">
                        <v-chip :small="$root.$mobileView" label outlined class="mb-1" color="green">{{(!$root.$mobileView) ? 'le :' : ''}} {{ $date(item.ass_departure_date).format('DD/MM/YYYY') }}</v-chip><br />
                        <v-chip :small="$root.$mobileView" label outlined class="mb-1" color="green"><v-icon small class="mr-1">mdi-clock-outline</v-icon>{{ item.ass_departure_time }}</v-chip><br />
                        <v-chip v-if="item.ass_doc_id"     label outlined class="mb-1 pa-2 pb-2 pl-10 pr-10" color="secondary" @click.stop.prevent="downloadVouch(item.ass_doc_id)">
                            <v-icon left color='red' title="Télécharger le rapport">
                                mdi-file-download
                            </v-icon>
                        </v-chip>
                    </v-col>
                </v-row>
            </v-card>
        </v-hover>
    </v-col>
    </v-row>
    <v-alert v-if="filteredList.length === 0" type="error" class="mt-4">
    Aucune tache enregistré
    </v-alert>
    <v-pagination 
        v-if="pagination.totalItems > 0"
        v-model="page" 
        :length="Math.ceil(pagination.totalItems / (pagination.rowsPerPage === -1 ? pagination.totalItems : pagination.rowsPerPage))" 
        :total-visible="7"
        class="mt-4 d-flex justify-center"
        @input="fetchList"
    ></v-pagination>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useAssignmentStore } from '@/stores/assignment'
import { useDocumentStore } from '@/stores/document'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'

export default {
    name: 'assignments-list',
    props: [ 'sit_id', 'ass_sit_id_old', 'livestockId', 'switchTab' ],
    computed: {
        ...mapState(useAssignmentStore, {itemList: 'itemList', metaItems: 'metaItems' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        filteredList() {
            if (!this.search) return this.itemList;
            
            const searchLower = this.search.toLowerCase();
            return this.itemList.filter(item => {
                return (
                    item.sit_name.toLowerCase().includes(searchLower) ||
                    item.old_sit_name.toLowerCase().includes(searchLower) //|| item.lst_site.toLowerCase().includes(searchLower)
                );
            });
        }
    },
    data: function () {
        return {
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            page: 1,
            headers: [
                { text: 'Site', value: 'ass_sit_id', align: 'left'},
                { text: 'Statut', value: 'ass_sta_id', align: 'left'},
                { text: 'Date départ', value: 'ass_departure_date', align: 'left'},
                { text: 'Heure départ', value: 'ass_departure_time', align: 'left'},
                { text: 'Action', value: 'ass_id', align: 'right'},
            ],
        }
    },
    async mounted () {
        if(this.$root.$mobileView){
            this.headers = [
                { text: 'Site', value: 'ass_sit_id', align: 'left'},
                { text: 'Date départ', value: 'ass_departure_date', align: 'left'},
                { text: 'Action', value: 'ass_id', align: 'right'},
            ]
        }

        await this.fetchList()
    },
    methods: {
        ...mapActions(useAssignmentStore, {fetchItems: 'fetchItems'}),
        ...mapActions(useDocumentStore, { downloadDocument: 'downloadItem' }),
        async fetchList(){
            const perPage = this.pagination.rowsPerPage === -1 ? 9999 : this.pagination.rowsPerPage;
            let params  = `?page=${this.page}&per_page=${perPage}`
            params     += `&order_by=ass_departure_date,ass_departure_time&order_direction=desc`
            params     += ( this.sit_id ) ? '&sit_id=' + this.sit_id : ''
            //params     += ( this.ass_sit_id_old ) ? '&ass_sit_id_old=' + this.ass_sit_id_old : ''
            params     += ( this.livestockId ) ? '&extended=withsites,withlivestock&ali_lst_id=' + this.livestockId : '&extended=withsites'
            
            await this.fetchItems( params )
            // Mise à jour du total depuis la réponse API
            if (this.metaItems) {
                this.pagination.totalItems = this.metaItems.total;
            }
        },
        async downloadVouch(docId){
            const report = await this.downloadDocument( docId )
            this.$download(report.blob, 'cr_visite', report.contentType)
        },
    },
}
</script>